/* eslint-disable @typescript-eslint/no-unused-vars */
import type { Maybe } from '@backmarket/utils/types/Maybe'
import { z } from 'zod/mini'

import type { Equal, ExpectTrue } from '../types/validation'

import { type ContentLink, ContentLinkSchema } from './content-link'
import { type CmsIcon, CmsIconSchema } from './icon'

/* TypeScript */
export type CategoryEntry = {
  id: string
  name: string
  link: ContentLink
  icon?: Maybe<CmsIcon>
  subCategories: SubCategory[]
}

export type SubCategory = Omit<CategoryEntry, 'subCategories'>

export type CategoryTreeApiProps = {
  technicalName?: Maybe<string>
  title: string
  categoryTree: CategoryEntry[]
}

/* Schemas */
const CategoryEntrySchema = z.object({
  id: z.string(),
  name: z.string(),
  link: ContentLinkSchema,
  icon: z.nullish(CmsIconSchema),
  // re-declared because "we can't use it before its declaration" warning loop ...
  subCategories: z.array(
    z.object({
      id: z.string(),
      name: z.string(),
      link: ContentLinkSchema,
      icon: z.nullish(CmsIconSchema),
    }),
  ),
})

export const CategoryTreeApiPropsSchema = z.object({
  technicalName: z.nullish(z.string()),
  title: z.string(),
  categoryTree: z.array(CategoryEntrySchema),
})

/* Schemas validation */
type TestCategoryTreeProps = ExpectTrue<
  Equal<CategoryTreeApiProps, z.infer<typeof CategoryTreeApiPropsSchema>>
>
